import type { ReactNode } from 'react'
import { Row } from 'src/shared/components/Semantic/all'

export const CatalogHeader = ({
  icon,
  title,
  action,
}: {
  icon: ReactNode
  title: string
  action?: ReactNode
}) => (
  <Row className="items-center gap-2 flex-wrap">
    {icon}
    <h1>{title}</h1>
    {action}
  </Row>
)
